<script setup>
import { onMounted, ref, inject, watch, nextTick } from "vue"
import { useRoute } from "vue-router";
import PreviewImg from "@/components/common/PreviewImg";
import i18n from "@/i18n"
import fileActionCom from "../common/fileAction.vue";
import {
    // getFileUrl,
    getProductTemplateMenu, sankey_v3,
} from "@/service";
import { showMessage } from '@/utils/hooks/message';
import { getLangValue, getLangValueByKey } from "@/utils/common"; //获取后端语言
const route = useRoute()
const activeImageSrc = ref("")
const showPreviewImg = ref(false)
const detailInfo = inject('detailInfo')
const menuList = ref([])
const table_name = inject('table_name')
const loading = inject('loading'); // loading
const showChart = ref(true)
const showType = ref(true)
const templateNameList = inject('templateNameList')
import {
    // sankeyChart,
    sankey1Chart
} from "@/utils/chart.js"
import SankeyTab from "./../common/SankeyTab.vue";
// const fileList  =ref({})
const product_info = ref({
    imageList: [],
    compositionStructureList: [],
    uploadFileList: [],
    trademark: {
        fileList: [],
        name: '',
        name_en: '', // 商标名称
    }, // 商标 信息
    product_wash: {}, // 产品洗涤说明
    product_recycle: {}, // 产品回收说明
})
const legends = ref([])
const mychartRef = ref(null)
const handleImgPreview = (item) => {
    // 预览图片
    activeImageSrc.value = item;
    if (activeImageSrc.value == "") {
        return;
    }
    showPreviewImg.value = true;
}
const setChart = (data) => {
    // 显示图表
    let options = {
        chartDom: mychartRef.value,
        data: data,
        origin: route.query.origin || ''
    };
    sankey1Chart(options);
}
const getTemplateMenu = async () => {
    // 获取菜单信息
    let data = sessionStorage.getItem('t_menuList') ? JSON.parse(sessionStorage.getItem('t_menuList')) : []
    if (data.length == 0) {
        const resp = await getProductTemplateMenu();
        if (resp) {
            menuList.value = resp.payload
        }
    } else {
        menuList.value = data
    }
}

const filterImglist = (valList, imageInfo) => {
    // 筛选图片信息
    if (valList && valList.length && Object.keys(valList).length) {
        const fileList = valList.map(item => {
            return imageInfo[item] || []
        })
        return fileList
    }
    return []
}
const getsankey_v3 = async () => {
    // 获取桑基图信息
    let params = {
        table_name: table_name.value,
        database_id: detailInfo.value.id,
    }
    const reps = await sankey_v3(params)
    if (reps.code == 1) {
        showMessage('danger', reps.message)
        return
    }
    if (reps.payload.links.length && reps.payload.nodes.length) {
        nextTick(() => {
            setChart(reps.payload)
            // 去重
            legends.value = reps.payload.codes.filter((value, index, self) =>
                index === self.findIndex((t) => (
                    t.title === value.title
                ))
            );
        })
        // console.log(legends.value);
    } else {
        showChart.value = false
    }

}

onMounted(() => {
    getTemplateMenu()
    // setChart();
})

watch(detailInfo, (val) => {
    // 设置产品信息部分
    loading.value = true
    const { comfort_info, structures } = val
    const heList = comfort_info.children.filter(item => item.key == "comfort_info_humidity_heat_comfort" && item.show)
    if (heList.length == 0) {
        showType.value = false;
    }
    // 2d图 设计版型 虚拟合身度
    const { product_info: _product_info } = val
    // const upList = _product_info.children.filter(item => (item.key == '2D版型' && item.show))
    const upList = _product_info.children.filter(item => (item.key.indexOf('product_info_product_picture') > -1 || item.key.indexOf('product_info_product_style') > -1 || item.key.indexOf('product_info_product_pattern') > -1 || item.key.indexOf('product_info_virtual_fit') > -1) && item.show)
    if (upList.length) {
        let srcList = []  //存储所有图片id
        upList.filter(item => item.key == 'product_info_product_style').forEach(item => {
            let m = {
                name: item.name,
                name_en: item.name_en,
                value: item.value,
                fileList: [],
            }
            if (item.value != null) {
                srcList = [...srcList, ...item.value]
            }
            product_info.value.imageList.push(m)
        })

        // upList.filter(item => item.key.indexOf('设计版型') > -1).forEach(item => {
        upList.filter(item => item.key == 'product_info_product_pattern').forEach(item => {
            let m = {
                name: item.name,
                name_en: item.name_en,
                value: item.value,
                fileList: [],
            }
            if (item.value != null) {
                srcList = [...srcList, ...item.value]
            }
            product_info.value.imageList.push(m)
        })
        // upList.filter(item => item.key.indexOf('虚拟合身度') > -1).forEach(item => {
        upList.filter(item => item.key == 'product_info_virtual_fit').forEach(item => {
            let m = {
                name: item.name,
                name_en: item.name_en,
                value: item.value,
                fileList: [],
                fieldsList: item.children ? item.children.map(ele => {
                    return {
                        name: ele.name, //字段名称
                        name_en: ele.name_en, //字段名称
                        unit: '', //字段单位
                        key: ele.key,
                        value: ele.value,
                        required: ele.required,
                        // isShow: ele.show,
                    }
                }) : []
            }
            if (item.value != null) {
                srcList = [...srcList, ...item.value]
            }
            product_info.value.imageList.push(m)
        })

        srcList = [...new Set(srcList)]
        // console.log(srcList);
        // 开始获取数据
        if (srcList.length) {
            product_info.value.imageList.forEach(item => {
                item.fileList = filterImglist(item.value, val.imageInfo)
            })
        }
    }
    // 产品商标
    const trademarkList = _product_info.children.find(item => (item.key == 'product_trademark' && item.show))
    product_info.value.trademark.fileList = []
    product_info.value.trademark.name = trademarkList.name
    product_info.value.trademark.name_en = trademarkList.name_en
    if (trademarkList) {
        // 获取信息
        if (trademarkList.value != null) {
            product_info.value.trademark.fileList = filterImglist(trademarkList.value, val.imageInfo);
        }
    }
    // 产品洗涤说明
    const product_washObj = _product_info.children.find(item => (item.key == 'product_washing_instructions' && item.show))
    if (product_washObj) {
        // 获取信息
        product_washObj.value = product_washObj.value || '-'
        product_washObj.value = product_washObj.value.replace('\n', '<br/>')
        product_info.value.product_wash = { ...product_washObj }
    }
    // 产品回收说明
    const product_recycleObj = _product_info.children.find(item => (item.key == 'product_recycling_discarding_instructions' && item.show))
    if (product_recycleObj) {
        // 获取信息
        product_recycleObj.value = product_recycleObj.value || '-'
        product_recycleObj.value = product_recycleObj.value.replace('\n', '<br/>')
        product_info.value.product_recycle = { ...product_recycleObj }
    }
    //组成结构
    const upList2 = _product_info.children.filter(item => (item.key == 'product_info_base_info_structure'))
    if (upList2.length) {
        // 获取数据
        // console.log(menuList.value);
        product_info.value.compositionStructureList = upList2[0].children.filter(item => item.show).map(item => {
            let m = {
                name: '',
                tableList: [],
                value: item.value,
                p_name: '',
                p_name_en: '',
            }
            let arr = []
            if (item.value != '无') {
                arr = templateNameList.value.filter(template => template.role_key === item.value)
            } else {
                arr = [{ name: getLangValueByKey("base.none"), name_en: getLangValueByKey("base.none", 'en') }]
            }
            m.p_name = arr.length ? arr[0].name : '';
            m.p_name_en = arr.length ? arr[0].name_en : '';
            if (item.extra.data) {
                m.tableList = item.extra.data;
                // 根据组成结构显示名称
                if (structures && structures.length && structures != null) {
                    for (const item in m.tableList) {
                        // 通过id匹配
                        const structure = structures.find(structure => structure.id === m.tableList[item].id);
                        if (structure) {
                            m.tableList[item].pid = structure.pid;
                            m.tableList[item].name = structure.name;
                        }
                    }
                }
            }
            return m
        })
    }
    // 底部文本项 & 附件项
    const upList3 = _product_info.children.filter(item => item.extra && item.show && (item.extra.myKey == '文本项' || item.extra.myKey == "文本项+附件项"))
    if (upList3.length) {
        product_info.value.uploadFileList = upList3.map(item => {
            let m = {
                name: item.name, // 文本名称
                name_en: item.name_en, // 文本名称
                type: item.extra.myKey,
                fieldList: item.children ? item.children.map(ele => {
                    return {
                        name: ele.name, //字段名称
                        name_en: ele.name_en, //字段名称
                        unit: ele.unit, //字段单位
                        key: ele.key,
                        value: ele.value,
                    }
                }) : [],
                value: item.value,
                imageList: [],
            }
            return m
        })
        product_info.value.uploadFileList.forEach(item => {
            if (item.value && item.value.length) {
                item.imageList = filterImglist(item.value, val.imageInfo)
            }
        })
    }
    //图表
    nextTick(() => {
        getsankey_v3();
    })
    loading.value = false
})


// watch(menuList, () => {
//     product_info.value.compositionStructureList.forEach(item => {
//         // console.log(item);
//         item.name = menuList.value.filter(item1 => item1.id == item.value).length ? menuList.value.filter(item1 => item1.id == item.value)[0].name : ''
//     })
// })

// watch(table_name, () => {
//     nextTick(() => {
//         getsankey_v3();
//     })
// })
</script>
<template>

    <div class="productInfo">
        <!-- 图片部分 -->
        <div v-for="(item, k) in product_info.imageList" :key="k">
            <div class="title my-4">{{ i18n.global.locale == 'en' ? item.name_en : item.name }}</div>
            <div class="d-flex justify-content-start align-items-center p-4" style="border: 1px solid #E9EBEC;">
                <div v-if="item.fileList.length" class="d-flex justify-content-start align-items-center">
                    <div class="d-flex justify-content-center align-items-center mx-2"
                        v-for="(image, kk) in item.fileList" :key="kk"
                        style=" width: 120px; height: 120px; border-radius: 4px;position: relative;">
                        <i v-if="image?.type == 'file'" class="ri-file-text-line"
                            style="font-size: 110px;color:#0AB39C"></i>
                        <img v-else :src="image?.url" alt="" style="object-fit: fill;max-height: 117px;"
                            @click="handleImgPreview(image?.url)" class="cursor-pointer" />
                        <fileActionCom :image="image" v-if="image?.showAction || true" />
                    </div>
                </div>
                <div v-else class="w-100 d-flex justify-content-center">
                    <Empty :flag="1"></Empty>
                </div>
            </div>
            <div v-if="item.fieldsList && item.fieldsList.length">
                <div class="my-2" style="color: #6691E7; text-decoration: underline;">
                    <a target="_blank" style="color: #6691E7" v-if="item.fieldsList[0].value"
                        :href="item.fieldsList[0].value"> {{ item.fieldsList[0].value
                        }}</a>
                </div>
            </div>
        </div>
        <!-- 组成结构 -->
        <!-- 判断是否需要显示 -->
        <div v-if="product_info.compositionStructureList.length">
            <div class="title py-4">{{
                getLangValue('product-template', 'compositionStructure')
            }}</div>
            <div class=" tableList">
                <div v-if="product_info.compositionStructureList.length">
                    <div v-for="(item, k) in product_info.compositionStructureList" :key="k">
                        <div class="title p-3" style="border-bottom: 1px solid #E9EBEC;">{{ i18n.global.locale == 'en' ?
                            item.p_name_en : item.p_name }}</div>
                        <div class="px-3 my-2">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <!-- border-right: 1px solid #E9EBEC -->
                                        <th scope="col" width="10%" style="font-weight: bold; font-size: 12px;">
                                            {{ getLangValue("attribute.number") }}</th>
                                        <th scope="col" width="25%" style="font-weight: bold; font-size: 12px;">
                                            {{ getLangValue("attribute.pid") }}</th>
                                        <th scope="col" width="25%" style="font-weight: bold; font-size: 12px;">
                                            {{ getLangValue("attribute.name") }}</th>
                                        <th scope="col" width="25%" style="font-weight: bold; font-size: 12px;"
                                            v-if="showType">
                                            {{ getLangValue("attribute.structure") }}</th>
                                        <th scope="col" width="25%" style="font-weight: bold; font-size: 12px;">
                                            {{ getLangValue('product-template', "proportion") }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(tableItem, kk) in item.tableList" :key="kk">
                                        <td style="" scope="row">{{ kk + 1 }}</td>
                                        <td style="">{{ tableItem.pid || tableItem.id }}</td>
                                        <td style="">{{ tableItem.name }}</td>
                                        <td style="" v-if="showType">{{tableItem.layer? tableItem.layer
                                            ==
                                            'shell' ? getLangValue('attribute.shell') :
                                            tableItem.layer == 'interlayer' ? getLangValue('attribute.interlayer') :
                                                getLangValue('attribute.lining') : '-' }}</td>
                                        <td style="">{{ tableItem.proportion }}%</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div v-else class="w-100 d-flex justify-content-center">
                    <Empty :flag="1"></Empty>
                </div>

            </div>
        </div>
        <!-- 成分结构 -->
        <div style="position: relative;" v-show="showChart">
            <SankeyTab v-model:currentTab="hand" :legends="legends"></SankeyTab>
            <div ref="mychartRef" id="product-mychart" style="height: 400px;"></div>
        </div>
        <!-- 增加商标、产品洗涤说明、产品回收、丢弃说明 -->
        <div>
            <div class="title py-4">{{ i18n.global.locale == 'en' ? product_info.trademark.name_en :
                product_info.trademark.name }}</div>
            <div class="d-flex justify-content-start align-items-center p-4" style="border: 1px solid #E9EBEC;">
                <div v-if="product_info.trademark.fileList.length"
                    class="d-flex justify-content-start align-items-center">
                    <div class="d-flex justify-content-center align-items-center mx-2"
                        v-for="(image, kk) in product_info.trademark.fileList" :key="kk"
                        style=" width: 120px; height: 120px; border-radius: 4px;position: relative;">
                        <i v-if="image?.type == 'file'" class="ri-file-text-line"
                            style="font-size: 110px;color:#0AB39C"></i>
                        <img v-else :src="image?.url" alt="" style="object-fit: fill;max-height: 117px;"
                            @click="handleImgPreview(image?.url)" class="cursor-pointer" />
                        <fileActionCom :image="image" v-if="image?.showAction || true" />
                    </div>
                </div>
                <div v-else class="w-100 d-flex justify-content-center">
                    <Empty :flag="1"></Empty>
                </div>
            </div>
        </div>
        <!-- 产品洗涤说明-->
        <div>
            <div class="title py-4">{{ i18n.global.locale == 'en' ? product_info.product_wash.name_en :
                product_info.product_wash.name }}</div>
            <div class="d-flex justify-content-start align-items-center px-2">
                <span v-html="product_info.product_wash.value"></span>
            </div>
        </div>
        <!--产品回收、丢弃说明 -->
        <div >
            <div class="title py-4">{{ i18n.global.locale == 'en' ? product_info.product_recycle.name_en :
                product_info.product_recycle.name }}</div>
            <div class="d-flex justify-content-start align-items-center px-2">
                <span v-html="product_info.product_recycle.value"></span>
            </div>
        </div>
        <!-- 文本项和附件项信息 -->
        <div v-if="product_info.uploadFileList.length" class="pb-2">
            <div v-for="(item, k) in product_info.uploadFileList" :key="k">
                <div class="title py-4" style="border-bottom: 1px solid #E9EBEC; ">{{ i18n.global.locale == 'en'
                    ? item.name_en : item.name }}</div>
                <template v-if="item.type == '文本项'">
                    <div class="p-2" v-if="item.fieldList.length">
                        <div v-for="(aa, kk) in item.fieldList" :key="kk" class="d-flex p-2"
                            style="border-bottom: 1px solid #E9EBEC; ">
                            <div style="font-weight: bold; flex: 2; max-width: 200px;">
                                {{ i18n.global.locale == 'en' ? aa.name_en : aa.name }}
                            </div>
                            <div style=" flex: 6;">
                                {{ aa.value ? aa.value : '-' }}{{ aa.value && aa.unit ? `${aa.unit}` : '' }}
                            </div>
                        </div>
                    </div>
                    <Empty v-else></Empty>
                </template>
                <template v-else>
                    <template v-if="item.fieldList.length || item.imageList.length">
                        <div style="color:#212529" class="row d-flex justify-content-start px-3"
                            v-if="item.fieldList.length">
                            <!-- <div class="col-6 my-1 d-flex align-items-center" v-for="(item, k) in item.fieldList"
                                :key="k">
                                <div class="mx-2"
                                    style="background-color: #9599AD; width:4px; height: 4px; border-radius: 100%; display: inline-block;">
                                </div>
                                <span>{{ item.name }} ：{{ item.value ? item.value : '-' }}{{ item.value && item.unit ?
                                    `${item.unit}` : '' }}</span>
                            </div> -->
                            <div v-for="(aa, kk) in item.fieldList" :key="kk" class="d-flex p-2"
                                style="border-bottom: 1px solid #E9EBEC; ">
                                <div style="font-weight: bold; flex: 2; max-width: 200px;">
                                    {{ i18n.global.locale == 'en' ? aa.name_en : aa.name }}
                                </div>
                                <div style=" flex: 6;">
                                    {{ aa.value ? aa.value : '-' }}{{ aa.value && aa.unit ? `${aa.unit}` : '' }}
                                </div>
                            </div>
                        </div>
                        <div class="qualityInspectionReport py-4 my-2" v-if="item.imageList.length">
                            <div class="d-flex justify-content-start align-items-center ">
                                <div class="d-flex justify-content-center align-items-center mx-2 file-view"
                                    v-for="(image, kk) in item.imageList" :key="kk"
                                    style=" width: 120px; height: 120px; border-radius: 4px; position: relative;">
                                    <i v-if="image.type == 'file'" class="ri-file-text-line"
                                        style="font-size: 110px;color:#0AB39C"></i>
                                    <img v-else :src="image.url" alt="" style="object-fit: fill;max-height: 117px;"
                                        @click="handleImgPreview(image.url)" class="cursor-pointer" />
                                    <!-- 文件操作按钮 -->
                                    <fileActionCom :image="image" v-if="image.showAction || true" />
                                </div>
                            </div>
                        </div>
                    </template>
                    <Empty v-else></Empty>
                </template>
            </div>
        </div>
        <PreviewImg v-model:showPreviewImg="showPreviewImg" :src="activeImageSrc" v-if="showPreviewImg"></PreviewImg>
    </div>
    <Empty
        v-if="product_info.imageList.length == 0 && product_info.compositionStructureList.length == 0 && product_info.uploadFileList.length == 0">
    </Empty>
</template>
